import React from "react";
import { useTranslation } from "react-i18next";
import { ListAndSearchAllBookingsTypeEnum } from "@rentablo/api/apiv1";
import { MultiSelect } from "./MultiSelect";

export type BookingTypeFilter = ListAndSearchAllBookingsTypeEnum;

// The usual ones first. No "switch": the Finanzfluss app found that filtering
// by it makes the API answer with an error.
export const BOOKING_TYPE_FILTERS: BookingTypeFilter[] = [
  "buy",
  "sell",
  "dividend",
  "book_in",
  "book_out",
  "fees",
  "cap_gains_tax",
  "cap_gains_tax_refund",
  "pre_tax_allowance",
  "retained_dividend",
  "purchase_right",
  "split",
  "reverse_split",
  "carve_out",
];

interface Props {
  selected: BookingTypeFilter[];
  onChange: (types: BookingTypeFilter[]) => void;
}

export const BookingTypeSetting = ({ selected, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <MultiSelect
      label={t(
        "components.depotsStatistic.bookingsTable.mobile.typeFilter.label"
      )}
      options={BOOKING_TYPE_FILTERS.map((type) => ({
        value: type,
        label: t(`bookingTypes.${type}`),
      }))}
      selected={selected}
      onChange={onChange}
      allLabel={t(
        "components.depotsStatistic.bookingsTable.mobile.typeFilter.all"
      )}
      countLabel={(count) =>
        t(
          "components.depotsStatistic.bookingsTable.mobile.typeFilter.selected",
          { count }
        )
      }
    />
  );
};
